import * as userActions from '../user/actions';
import * as lawsSourcesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsSourcesReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsSourcesActions.SET_LAWS_SOURCES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsSourcesActions.SET_LAWS_SOURCES_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsSourcesActions.SET_LAWS_SOURCES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsSourcesActions.ABORT_SOURCES_REQUEST:
            return initialState;

        case lawsSourcesActions.CLEAN_LAWS_SOURCES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsSources/reducer.js